/**
 * Customer Module Constants - Application-wide constants
 * 
 * Migrated from seo-engine-webtools-customer-module
 */

import { EngineType } from '@/types/customer';

// Engine color coding
export const ENGINE_COLORS: Record<EngineType, string> = {
  GSC: '#4285F4',   // Google Blue
  BING: '#00809D',  // Bing Teal
  GA4: '#F9AB00',   // Google Analytics Orange
  GBP: '#34A853',   // Google Green
};

// Lowercase aliases for convenience
export const ENGINE_COLORS_LOWER = {
  google: '#4285F4',  // GSC
  bing: '#00809D',    // Bing
  ga4: '#F9AB00',     // GA4
  gbp: '#34A853',     // GBP
} as const;

export const ENGINE_LABELS: Record<EngineType, string> = {
  GSC: 'Google Search Console',
  BING: 'Bing Webmaster',
  GA4: 'Google Analytics 4',
  GBP: 'Google Business Profile',
};

export const ENGINE_SHORT_LABELS: Record<EngineType, string> = {
  GSC: 'GSC',
  BING: 'Bing',
  GA4: 'GA4',
  GBP: 'GBP',
};

// Status colors with named keys
export const STATUS_COLORS = {
  HEALTHY: { color: '#2e7d32', bg: '#e8f5e9' },
  FRESH: { color: '#2e7d32', bg: '#e8f5e9' },
  STALE: { color: '#ed6c02', bg: '#fff3e0' },
  ERROR: { color: '#d32f2f', bg: '#ffebee' },
  MISSING: { color: '#757575', bg: '#f5f5f5' },
} as const;

// Semantic color aliases for UI components
export const SEMANTIC_COLORS = {
  success: '#2e7d32',
  warning: '#ed6c02',
  error: '#d32f2f',
  info: '#0288d1',
  neutral: '#757575',
} as const;

// Job status colors
export const JOB_STATUS_COLORS = {
  PENDING: { color: '#757575', bg: '#f5f5f5' },
  RUNNING: { color: '#0288d1', bg: '#e3f2fd' },
  COMPLETED: { color: '#2e7d32', bg: '#e8f5e9' },
  FAILED: { color: '#d32f2f', bg: '#ffebee' },
  CANCELLED: { color: '#ed6c02', bg: '#fff3e0' },
} as const;

// Chart colors for multi-series
export const CHART_COLORS = [
  '#4285F4', // Blue
  '#34A853', // Green
  '#F9AB00', // Orange
  '#EA4335', // Red
  '#9c27b0', // Purple
  '#00BCD4', // Cyan
  '#FF5722', // Deep Orange
  '#607D8B', // Blue Grey
];

// Default date ranges
export const DATE_RANGES = {
  LAST_7_DAYS: 7,
  LAST_14_DAYS: 14,
  LAST_28_DAYS: 28,
  LAST_90_DAYS: 90,
} as const;

// Device types
export const DEVICE_TYPES = ['DESKTOP', 'MOBILE', 'TABLET'] as const;

// Pagination defaults
export const PAGINATION = {
  DEFAULT_PAGE_SIZE: 25,
  PAGE_SIZE_OPTIONS: [10, 25, 50, 100],
} as const;
